import { Injectable } from '@angular/core';
import { GLOBAL } from './global.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class TareasService {
	public url: string;

  constructor(public _http: HttpClient) { 
    this.url = GLOBAL.url;
  }

 
  addActividad(edit_cat, token): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    let json = JSON.stringify(edit_cat);
    let params = 'json='+json;
  	 return this._http.post(this.url + 'add_actividad', params, {headers: headers});
  }

  edActividad(edit_cat, token): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    let json = JSON.stringify(edit_cat);
    let params = 'json='+json;
  	 return this._http.post(this.url + 'ed_actividad', params, {headers: headers});
  }
  delActividad(edit_cat, token): Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    let json = JSON.stringify(edit_cat);
    let params = 'json='+json;
  	 return this._http.post(this.url + 'del_actividad', params, {headers: headers});
  }
  getUsersCat(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'equipo_list', params, {headers: headers});
  }
  addUsersProyect(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'add_equipo_proyect', params, {headers: headers});
  }
  delUsersProyect(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'del_equipo_proyect', params, {headers: headers});
  }
  taskformAdd(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_add', params, {headers: headers});
  }
  
  subir_archivos(file,id,token): Observable<any>{
    var myFormData = new FormData();
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('file', file);
    myFormData.append('id', id);
    myFormData.append('token', token);
    return this._http.post(this.url + 'subir_archivo', myFormData, { headers: headers,  reportProgress: true, observe: 'events' });
  }

  taskAdd(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_create', params, {headers: headers});
  }
  taskEdit(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_update', params, {headers: headers});
  }
  taskEditUsers(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_update_users', params, {headers: headers});
  }
  taskDel(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_del', params, {headers: headers});
  }
  DelUser(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_del_users', params, {headers: headers});
  }
  DelDoc(info, token): Observable<any>{
    let json = JSON.stringify(info);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_del_doc', params, {headers: headers});
  }
  taskInfo(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'task_info', params, {headers: headers});
  }

  taskView(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'ver_info_task', params, {headers: headers});
  }
  taskData(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'ver_data_task', params, {headers: headers});
  }

  AddComentario(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'add_comentario', params, {headers: headers});
  }
  DelComentario(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'del_comentario', params, {headers: headers});
  }
  TareasUsuario(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'tareas_usuario', params, {headers: headers});
  }
  TareasUsuarioRealizadas(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'tareas_usuario_realizadas', params, {headers: headers});
  }
  VerEstatus(token): Observable<any>{
    let params = 'json=';
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'ver_estatus', params, {headers: headers});
  }
  AddEstatus(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'insertar_estatus', params, {headers: headers});
  }
  EditEstatus(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'editar_estatus', params, {headers: headers});
  }
  DelEstatus(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'del_estatus', params, {headers: headers});
  }

  Calendario(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'calendario', params, {headers: headers});
  }
  CalendarioProyecto(cat, token): Observable<any>{
    let json = JSON.stringify(cat);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'calendario_proyecto', params, {headers: headers});
  }
  

}
